export default __webpack_public_path__ + "static/media/item1.a8b3985b.png";